module.exports = __webpack_public_path__ + "static/img/rightUpTwo.30d394d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/matrixImg/rightUpTwo.png
// module id = gX56
// module chunks = 0